import type { PrefabData } from "./prefabData";

// Robot Intro Level (level 21)
// Floor layer (0): GrayStoneFloor1, GrayStoneFloor2, DarkConcreteFloor, ConcreteFloor, WarningFloor.
// Entity layer (1): walls, doors, barrels, loot boxes, spawners, traps, stairs, terminal.
export const robotIntroLevelData: PrefabData = {
	legend: {
		// Floor types
		".": "GrayStoneFloor1",
		",": "GrayStoneFloor2",
		":": "DarkConcreteFloor",
		_: "ConcreteFloor",
		w: "WarningFloor",
		// Walls
		"#": "ConcreteBlock",
		M: "MetalBlock",
		// Doors
		W: "WoodenDoor",
		"+": "MetalDoor",
		B: { class: "BlastDoor", props: { group: "donotopen" } },
		N: { class: "BlastDoor", props: { group: "nextlevel" } },
		// Barrels & loot
		E: "EmptyBarrel",
		G: "GasBarrel",
		L: "LootBox",
		// Stairs
		D: { class: "Downstairs", props: { destination: 0 } },
		U: { class: "Upstairs", props: { destination: 0 } },
		// Spawners & traps
		S: { class: "RobotSpawner", props: { active: false, spawns: "Robot" } },
		A: "ActivateRobotSpawnersTrap",
		// Terminal
		R: { class: "RobotEntranceTerminal", props: { group: "nextlevel" } },
	},
	layers: [
		// Layer 0: floors
		[
			"                                       ", // y=2
			"     ___                               ", // y=3
			"       _                               ", // y=4
			"    _____  __                          ", // y=5
			"    _________                          ", // y=6
			"    _____  __                          ", // y=7
			"      _                                ", // y=8
			"      _                                ", // y=9
			"      _                                ", // y=10
			"      _                                ", // y=11
			".. w..... ........................ ... ", // y=12
			".. w.....w............................ ", // y=13
			"...w.....w........................ ... ", // y=14
			".. w.....w........................     ", // y=15
			".. w..... ........................     ", // y=16
			"      :                    ,,,         ", // y=17
			"      :                                ", // y=18
			"      :                                ", // y=19
			"      :                                ", // y=20
			"      :                                ", // y=21
			"   ::::                                ", // y=22
			"   ::::                                ", // y=23
			"   ::::                                ", // y=24
			"                                       ", // y=25
		],
		// Layer 1: entities (walls, doors, spawners, traps, barrels, stairs, terminal)
		[
			"    #####                              ", // y=2
			"    #G  #                              ", // y=3
			"   ####W######                         ", // y=4
			"   # G   ## L#                         ", // y=5
			"   #EG   ++ L#                         ", // y=6
			"   #E    ## L#                         ", // y=7
			"   ### #######                         ", // y=8
			"     # #                               ", // y=9
			"     # #                               ", // y=10
			"MMMM##W###MM####MM###M###MM#######MMMMM", // y=11
			"  M      MMS    SM   S   SM       M   M", // y=12
			"  M                               N D M", // y=13
			"  B                 A             M   M", // y=14
			"  M                               MMMMM", // y=15
			"  M      MMS    S   MS   SM       #    ", // y=16
			"MMMM##W###MM####M###MM###MM R ####M    ", // y=17
			"     M M                  #####        ", // y=18
			"     M M                   ###         ", // y=19
			"     M M                               ", // y=20
			"  MMMM M                               ", // y=21
			"  M    M                               ", // y=22
			"  M U  M                               ", // y=23
			"  M    M                               ", // y=24
			"  MMMMMM                               ", // y=25
		],
	],
};
